import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  baseUrl: string = environment.baseUrl;

  userDetails!:Observable<any>;
  userDetailsBS!:BehaviorSubject<any>;

  constructor(
    private http: HttpClient
  ) { 
    this.userDetailsBS = <BehaviorSubject<any>>new BehaviorSubject(null);
    this.userDetails = this.userDetailsBS.asObservable();
  }

  verifyCurrentAppPin(body:any){
    return this.http.post(this.baseUrl + 'Profile/User/VerifyCurrentAppPin', body);
  }

  changeAppPin(body:any){
    return this.http.post(this.baseUrl + 'Profile/User/ChangeAppPin',body);
  }

  changeProfileImage(body:any){
    return this.http.post(this.baseUrl + 'Profile/User/UpdateProfilePicture', body);
  }

  updateUserDetails(data:any){
    this.userDetailsBS.next(data);
  }
  
}
